module.exports = __webpack_public_path__ + "img/svg/background-about-us-mobile.ad3e5535f6ea1b685c3e41a82c5e1602.svg";